import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import SplitText from "./SplitText"
import CustomEase from "./CustomEase"

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(SplitText)
gsap.registerPlugin(CustomEase)

const customEase = CustomEase.create(
  "custom",
  "M0,0 C0.1,0 0.148,0.034 0.182,0.136 0.216,0.238 0.239,0.685 0.448,0.886 0.55,0.984 0.704,1 1,1"
)

gsap.defaults({
  ease: customEase,
})

export { gsap, ScrollTrigger, SplitText }
